// extracted by mini-css-extract-plugin
export default {"title":"UPFGQHVzeHP5h4ZdCZ6h","text":"SSJOMsphoZl_gFZNrNDh"};